export default __webpack_public_path__ + "static/media/circleRed.20a3ad64.svg";